export default __webpack_public_path__ + "static/DW-Google-289177577d5f4906bb8b71f56b5cc2ec.svg";